import React, {useEffect, useState, forwardRef, useImperativeHandle} from 'react'
import CheckBoxHandle from 'sr/helpers/functions/CheckBoxHandle';
import { CheckBox } from 'sr/helpers/ui-components/company/CheckBox';
import { FormattedMessage } from 'react-intl';
import { Schedule } from '../Jsonalldata';
export const ScheduleChange = forwardRef((props:any , ref) => {
    const [schedule, setSchedule] = useState<any[]>([]);
    const [error, setError] = useState('');
    useEffect(()=> {
      setSchedule(props?.data?.schedule)
    },[props?.data])

    useEffect(()=>{
      const data = {
        schedule:schedule
      }
      props?.HandleDataProps(data)
    },[schedule])

      useImperativeHandle(ref, () => ({
        validateData: () => {
          if (!schedule || schedule.length === 0) {
            setError('Please select at least one Schedule')
            return false
          }
          setError('')
          return true
        }
      }))

  return (
    <div className='pb-4'>
        <p className='pt-8 text-base '><FormattedMessage id="RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.SCHEDULE.TITLE" defaultMessage="Schedule" /></p>
<div className="flex flex-wrap space-x-4">
{Schedule.map((data, index)=> (
<CheckBox
value={data.value}
onChange={(e) => CheckBoxHandle(e, schedule, setSchedule)}
checked = {schedule.includes(data.value)} 
     label={<FormattedMessage id={data?.label}/>}

/>
))}
   </div> 
   {error && <div className="text-red-500 text-sm mt-3">{error}</div>}
   </div>
   )
})
